module.exports = __webpack_public_path__ + "img/asesoria_msh.8b0f41cd.jpg";